import StakingTab from "./StakingTab";

export default StakingTab;
